import { CheckCircle2, Ruler, AlertTriangle, MapPin } from "lucide-react";

const NOTES = {
  exact: ["Endereço exato encontrado no mapa.", CheckCircle2, "text-emerald-400"],
  interpolated: ["Posição calculada pela numeração da rua, usando endereços vizinhos já mapeados.", Ruler, "text-emerald-400"],
  estimated: ["Posição calculada pela numeração da rua (em Marília cada número ≈ 1 metro).", Ruler, "text-primary"],
  approximate: ["Esse número fica além do trecho mapeado da rua. Confira o pin.", AlertTriangle, "text-secondary"],
  street: ["Sem número: o pin ficou no trecho da rua. Informe o número pra cravar o local.", AlertTriangle, "text-secondary"],
  place: ["Local encontrado pelo nome.", MapPin, "text-emerald-400"],
};

export const PrecisionNote = ({ precision, testid = "geo-precision" }) => {
  const note = NOTES[precision];
  if (!note) return null;
  const [text, Icon, color] = note;
  return (
    <p className={`text-[11px] font-medium flex items-start gap-1.5 ${color}`} data-testid={testid} data-precision={precision}>
      <Icon className="w-3.5 h-3.5 mt-px shrink-0" /> {text}
    </p>
  );
};

export default PrecisionNote;
